import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'antd'

import { ChevronDownIcon, ChevronUpIcon } from '@/components/Icons'

import styles from './B2BecSorting.module.scss'
import { defaultSortOptions, getSortOption } from './sortOptions'

interface SortOption {
  key: string
  text: string
  sortOrder: number
}

interface B2becSortingProps {
  options?: SortOption[]
  sortOption?: SortOption
  onSort?: (...args: unknown[]) => unknown
}

const B2becSorting = ({
  options = defaultSortOptions,
  sortOption,
  onSort,
}: B2becSortingProps) => {
  const { t } = useTranslation()
  const [selectedKey, setSelectedKey] = useState(
    sortOption?.sortOrder !== 0 ? sortOption?.key : null,
  )

  const handleSort = useCallback(
    ({ key }) => {
      const sort = getSortOption(key, options)

      setSelectedKey(sort?.key)
      onSort?.(sort)
    },
    [onSort, options],
  )

  const items = options
    .filter(({ sortOrder }) => sortOrder !== 0)
    .map(({ key, text }) => ({
      key,
      label: text ? t(text) : null,
    }))

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleSort,
        selectedKeys: [`${selectedKey}`],
      }}
    >
      <button
        className={styles.button}
        type="button"
        onClick={(e) => e.preventDefault()}
      >
        <div className={styles.iconsWrapper}>
          <ChevronUpIcon />
          <ChevronDownIcon />
        </div>
        <span>{t('sorting.button.sort')}</span>
      </button>
    </Dropdown>
  )
}

export default B2becSorting
